export default __webpack_public_path__ + "static/media/MDV_C__0003_Layer-3.acdaedd7.png";